import { gql } from "@apollo/client"
import { ChargePaymentRequest, QueryChargePaymentRequestArgs } from "@oysterhr/schema"
import { useQuery, InjectedOptions } from "@oysterhr/core"

const QUERY = gql`
  query InvoicingInvoiceDrawerPaymentHistory($paymentRequestId: ID!) {
    chargePaymentRequest(paymentRequestId: $paymentRequestId) {
      orders {
        strongId
        completedAt
        createdAt
        amount {
          subunit
          currencyCode
        }
        provider
      }
    }
  }
`

type QueryPayload = { chargePaymentRequest: ChargePaymentRequest }
type QueryArgs = QueryChargePaymentRequestArgs

export const useInvoiceCharges = (
  options: InjectedOptions<QueryPayload, QueryArgs> & { skip?: boolean },
) => useQuery<QueryPayload, QueryArgs>(QUERY, options)
